<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th class="col-1">불량원인</th>
							<td class="col-3"><el-input type="textarea" v-model="textarea1" maxlength="100" :rows="5" /></td>
							<th class="col-1">파일첨부</th>
							<td class="col-3">
								<file-upload-list
									id="fileList"
									:propFileList="resultFileList_"
									:isEditable="true"
									@onDownload="onDownloadFile"
								></file-upload-list>
							</td>
							<th class="col-1">개선대책</th>
							<td class="col-3"><el-input type="textarea" v-model="textarea1" maxlength="100" :rows="5" /></td>
						</tr>
						<tr>
							<th>개선LOT</th>
							<td><el-input v-model="input1" /></td>

							<th>제기일</th>
							<td><el-date-picker v-model="date1" type="date" /></td>
							<th>고품처리</th>
							<td><sf-select-group labelPosition="left" inputValue="All" :options="['ALL']" :onChange="() => {}" /></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { serviceComputed, serviceMethods } from '../../store/helpers';
import FileUploadList from '@qms/Components/FileUploadList.vue';
export default {
	components: { FileUploadList },
	data() {
		return {
			data: '',
			input1: '',
			textarea1: '',
			date1: ''
		};
	},
	props: {
		scrId: { type: String, default: '' },
		mainKey: { type: String, default: '' }
	},
	computed: {
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		async onDownloadFile(file) {
			const { fileId, fileSeq } = file;
			await this.fileDownload_({ fileId, fileSeq });
		}
	}
};
</script>

<style></style>
